import moment from 'moment/min/moment-with-locales';
import Strings from './../common/Strings';
import { dropSecondsAndMillisFromWorkLogMillis, getHoursFromMillis, getLoggedTimeFromMillis } from './workLog';
import { getProjectWithId } from './project';

const locale = window.navigator.userLanguage || window.navigator.language;
const isSafari = !!window.navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);

function exportCvs(rows, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    let csvContent = '';
    rows.forEach(rowArray => {
      const row = rowArray.join(',');
      csvContent += `${row}\r\n`;
    });
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    let csvContent = 'data:text/csv;charset=utf-8,';
    rows.forEach(rowArray => {
      const row = rowArray.join(',');
      csvContent += `${row}\r\n`;
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', fileName);
    // Setting target with Safari will open data in new window instead of downloading file
    if (!isSafari) {
      link.setAttribute('target', 'blank');
    }
    link.innerHTML = 'Download';

    document.body.appendChild(link); // Required for FF
    link.click();
    document.body.removeChild(link);
  }
}

function getTime(w) {
  let start = '';
  let end = '';

  if (w.startTimestamp) {
    start = moment(w.startTimestamp).format('h:mm A');
  }

  if (w.endTimestamp) {
    end = moment(w.endTimestamp).format('h:mm A');
  }

  return `${start} - ${end}`;
}

function getNotes(w) {
  const notes = w.notes ? w.notes.replace(/(\r\n|\n|\r)/gm, ' ') : '';
  return `"${notes}"`;
}

export function exportSingleDateCsv(date, workLogs) {
  const rows = [
    [
      Strings.EXPORT.date,
      Strings.EXPORT.time,
      Strings.EXPORT.project,
      Strings.EXPORT.hourlyRate,
      Strings.EXPORT.currency,
      Strings.EXPORT.hours,
      Strings.EXPORT.rawHours,
      Strings.EXPORT.cost,
      Strings.EXPORT.notes,
    ],
  ];
  workLogs.forEach(w => {
    const project = getProjectWithId(w.projectId);
    const millisToUse = dropSecondsAndMillisFromWorkLogMillis(
      w.totalLoggedMillis,
    );
    const hoursToUse = getHoursFromMillis(millisToUse);
    rows.push([
      moment(w.date)
        .locale(locale)
        .format('l'),
      getTime(w),
      project.name,
      project.hourlyRate,
      project.currencyCode,
      getLoggedTimeFromMillis(millisToUse),
      hoursToUse,
      Number.parseFloat((project.hourlyRate * hoursToUse).toFixed(2)),
      getNotes(w),
    ]);
  });

  const fileName = `iworkie-${date.locale(locale).format('l')}.csv`;
  exportCvs(rows, fileName);
}
export function exportSingleMonthCsv(date, workLogs) {
  const rows = [
    [
      Strings.EXPORT.date,
      Strings.EXPORT.time,
      Strings.EXPORT.project,
      Strings.EXPORT.hourlyRate,
      Strings.EXPORT.currency,
      Strings.EXPORT.hours,
      Strings.EXPORT.rawHours,
      Strings.EXPORT.cost,
      Strings.EXPORT.notes,
    ],
  ];
  let totalLoggedMillis = 0;
  let totalEarnings = 0.0;
  workLogs.forEach(w => {
    const project = getProjectWithId(w.projectId);
    const millisToUse = dropSecondsAndMillisFromWorkLogMillis(
      w.totalLoggedMillis,
    );
    const hoursToUse = getHoursFromMillis(millisToUse);
    totalLoggedMillis += millisToUse;
    totalEarnings += Number.parseFloat(
      (project.hourlyRate * hoursToUse).toFixed(2),
    );
    rows.push([
      moment(w.date)
        .locale(locale)
        .format('l'),
      getTime(w),
      project.name,
      project.hourlyRate,
      project.currencyCode,
      getLoggedTimeFromMillis(millisToUse),
      hoursToUse,
      Number.parseFloat((project.hourlyRate * hoursToUse).toFixed(2)),
      getNotes(w),
    ]);
  });

  rows.push([
    Strings.EXPORT.total,
    '',
    '',
    '',
    '',
    getLoggedTimeFromMillis(totalLoggedMillis),
    getHoursFromMillis(totalLoggedMillis),
    totalEarnings,
    '',
  ]);

  const fileName = `iworkie-${date.locale(locale).format('MMMM YYYY')}.csv`;
  exportCvs(rows, fileName);
}

export function exportProjectCsv(project, graphDate, workLogs) {
  const rows = [
    [
      Strings.EXPORT.date,
      Strings.EXPORT.time,
      Strings.EXPORT.hourlyRate,
      Strings.EXPORT.currency,
      Strings.EXPORT.hours,
      Strings.EXPORT.rawHours,
      Strings.EXPORT.cost,
      Strings.EXPORT.notes,
    ],
  ];
  let totalLoggedMillis = 0;
  let totalEarnings = 0.0;
  workLogs.forEach(w => {
    const millisToUse = dropSecondsAndMillisFromWorkLogMillis(w.totalLoggedMillis);
    const hoursToUse = getHoursFromMillis(millisToUse);
    totalLoggedMillis += millisToUse;
    totalEarnings += Number.parseFloat((project.hourlyRate * hoursToUse).toFixed(2))
    rows.push([
      moment(w.date)
        .locale(locale)
        .format('l'),
      getTime(w),
      project.hourlyRate,
      project.currencyCode,
      getLoggedTimeFromMillis(millisToUse),
      hoursToUse,
      Number.parseFloat((project.hourlyRate * hoursToUse).toFixed(2)),
      getNotes(w),
    ]);
  });

  rows.push([
    Strings.EXPORT.total,
    '',
    project.hourlyRate,
    project.currencyCode,
    getLoggedTimeFromMillis(totalLoggedMillis),
    getHoursFromMillis(totalLoggedMillis),
    Number.parseFloat(totalEarnings.toFixed(2)),
    '',
  ]);

  let time = Strings.COMMON.lifetime;
  if (graphDate !== Strings.COMMON.lifetime) {
    time = moment(graphDate).format('MMMM YYYY');
  }
  const fileName = `iworkie-${Strings.EXPORT.project}-${
    project.name
  }-${time}.csv`;
  exportCvs(rows, fileName);
}



// WEBPACK FOOTER //
// ./src/helpers/export.js